import simpleFetch from "../../../utils/simpleFetch";

class PersonalDataApi {
    static get(model, query, headers) {
        return simpleFetch("GET", model.path, { query, headers });
    }

    static getItem(model, query, headers) {
        return simpleFetch("GET", model.path, { query, headers });
    }

    static patch(model, body, headers) {
        return simpleFetch("PATCH", model.path, { body, headers });
    }
}

export default PersonalDataApi;


// WEBPACK FOOTER //
// ./src/components/personal-data/personalDataApi.js